import axios from 'axios';

import type {
  FetchDocumentSignedUploadUrlArgs,
  CreateUserDocumentArgs,
  DeleteUserDocumentArgs,
  FetchUserDocumentsArgs,
  UpdateUserDocumentArgs,
} from './types/userDocument.types';
import type { ApiUserDocument } from '../schemas/userDocument.schema';
import type { ApiSignedUploadUrl } from './types/files.types';
import type { BaseApiResponse } from './types/api.types';

import {
  createUserDocumentApiArgs,
  updateUserDocumentApiArgs,
  mapUserDocumentFromApi,
} from './mappers/userDocument.mappers';
import { destroy, patch, post, get } from './axios';

export const fetchDocumentSignedUploadUrl = async ({
  mediaType,
  organizationId,
  userId,
}: FetchDocumentSignedUploadUrlArgs) => {
  const params = new URLSearchParams({ mediaType, organizationId, userId });
  const response = await get<BaseApiResponse<ApiSignedUploadUrl>>(
    `/v2/user-documents/signed-upload-url?${params.toString()}`,
  );
  return response?.data;
};

export const uploadFileToR2 = async (
  url: string,
  file: File,
): Promise<void> => {
  await axios.put(url, file, {
    headers: { 'Content-Type': file.type },
  });
};

export const createUserDocument = async (args: CreateUserDocumentArgs) => {
  const response = await post<ApiUserDocument>(
    '/v2/user-documents',
    createUserDocumentApiArgs(args),
  );
  return response?.data ? mapUserDocumentFromApi(response.data) : null;
};

export const fetchUserDocuments = async ({
  organizationId,
  userId,
}: FetchUserDocumentsArgs) => {
  const params = new URLSearchParams({ userId });
  if (organizationId) params.set('organizationId', organizationId);
  const response = await get<BaseApiResponse<ApiUserDocument[]>>(
    `/v2/user-documents?${params.toString()}`,
  );
  return (response?.data ?? []).map(mapUserDocumentFromApi);
};

export const updateUserDocument = async ({
  id,
  ...rest
}: UpdateUserDocumentArgs) => {
  const response = await patch<ApiUserDocument>(
    `/v2/user-documents/${id}`,
    updateUserDocumentApiArgs(rest),
  );
  return response?.data ? mapUserDocumentFromApi(response.data) : null;
};

export const deleteUserDocument = async ({ id }: DeleteUserDocumentArgs) => {
  await destroy(`/v2/user-documents/${id}`);
};
